'use strict';

var _ = require('lodash');
var CompetitorFaresChartDataProviderService = function CompetitorFaresChartDataProviderService($q, dataRetrieverService, dataRetrieverConstantsService, chartElementsConstants, userPreferencesService, SearchCriteriaRule, colorService, competitorFaresChartTimeWindowService, competitorFaresChartSearchDataService, competitorFaresCommonService) {
  var MAX_LEGEND_ITEMS = 5;
  function constructServiceOnFlights(screen, mode, selectedEntity) {
    var dataRetriever = competitorFaresCommonService.cloneDataRetriever(screen, mode);
    var brushFilters = dataRetriever.brushFilters();
    var defaultFlightId = _.get(selectedEntity, 'flightId');
    var defaultDepartureDateTimeMoment = _.get(selectedEntity, 'departureDateTimeMoment');
    var flightId = _.get(brushFilters, 'flightLevel.secondaryData[0].flightId', defaultFlightId);
    var originAndDestination = competitorFaresCommonService.getOriginAndDestination(screen, dataRetriever, selectedEntity);
    return {
      serviceId: originAndDestination[0] + '.' + flightId + '.' + originAndDestination[1],
      departureTimeMoment: _.get(brushFilters, 'flightLevel.secondaryData[0].departureTimeMoment', defaultDepartureDateTimeMoment)
    };
  }
  function getChartMode(mode) {
    if (mode === dataRetrieverConstantsService.MARKET_PRODUCT_GROUP_MODE) {
      return dataRetrieverConstantsService.MARKET_PRODUCT_COMPETITOR_FARE_MODE;
    }
    if (mode === dataRetrieverConstantsService.FLIGHT_COMPETITOR_FARE_MODE) {
      return dataRetrieverConstantsService.FLIGHT_COMPETITOR_FARE_MODE;
    }
    return dataRetrieverConstantsService.SERVICE_COMPETITOR_FARE_MODE;
  }
  function retrieveCompetitorData(origin, destination, departureDate, dtd, singleServiceId, mode) {
    var chartMode = getChartMode(mode);
    var competitorCurveDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.MARKET_SCREEN, chartMode);
    competitorCurveDataRetriever.defaultSortDefer = $q.all();
    competitorCurveDataRetriever.defaultSortCriteriaPromise = competitorCurveDataRetriever.defaultSortDefer.promise;
    var searchRules = [new SearchCriteriaRule({
      field: 'origin',
      operator: '=',
      leftOperand: origin
    }), new SearchCriteriaRule({
      field: 'destination',
      operator: '=',
      leftOperand: destination
    }), new SearchCriteriaRule({
      field: 'departureDate',
      operator: '=',
      leftOperand: departureDate
    })];
    competitorCurveDataRetriever.setCustomSearchCriteriaRules(searchRules);
    competitorCurveDataRetriever.updateAdditionalParameters({
      currentDtd: dtd,
      selectedService: singleServiceId
    });
    return competitorCurveDataRetriever.retrieveComponentData('competitor-fares-chart');
  }
  function buildLegendItem(data, fill, selected, disabled) {
    var result = {
      label: data.carrier,
      id: data.carrier,
      style: 'line',
      fill: fill,
      strokeWidth: '6',
      isHostFare: data.isHostFare
    };
    if (data.isHostFare) {
      result.permanent = true;
      result.dashed = true;
      result.customDash = '4,2';
    } else {
      result.selectable = !disabled;
      result.selected = selected && !disabled;
    }
    return result;
  }
  function getVerticalLine(dtd) {
    var anchorNow = 'end';
    if (userPreferencesService.getUserDateTimeSettings('defaultRTPView') === chartElementsConstants.DIRECTION.RTL) {
      anchorNow = 'start';
    }
    return [{
      dtd: dtd,
      caption: ['Today:', dtd, 'DTD'].join(' '),
      className: 'gte-today-line',
      textAnchor: anchorNow,
      color: '#999999'
    }];
  }
  function prepareDiscontinuousData(data, curveName, valueName) {
    var continuousSwitch = true;
    var curveData = data[curveName];
    return _.chain(curveData).reduce(function (result, item) {
      if (item[valueName] !== undefined) {
        if (continuousSwitch) {
          result.push([]);
          continuousSwitch = !continuousSwitch;
        }
        result[result.length - 1].push(item);
      } else if (!continuousSwitch) {
        continuousSwitch = !continuousSwitch;
      }
      return result;
    }, []).filter(function (item) {
      return item.length === 1;
    }).flatten().value();
  }
  function buildPointData(fareData) {
    return prepareDiscontinuousData(fareData, 'fareCurve', 'fare');
  }
  function matchByStops(item, filter) {
    if (filter.mode !== 'UNMATCHED') {
      return true;
    }
    if (filter.stops === 'non-stop') {
      return item.nbrOfStops === 0;
    } else if (filter.stops === 'connecting') {
      return item.nbrOfStops > 0;
    }
    return true;
  }
  function findServiceWithLowestFare(services, carrierCurvesFareMap, dtd) {
    var lowestFare = Number.MAX_VALUE;
    var lowestDtd;
    _.forEach(services, function (service) {
      var curvePointAtDTD = carrierCurvesFareMap[service.entryKey][dtd];
      if (curvePointAtDTD && curvePointAtDTD.fare !== undefined) {
        var fare = parseFloat(curvePointAtDTD.fare);
        if (lowestFare > fare) {
          lowestFare = fare;
          lowestDtd = {
            nbrOfStops: service.nbrOfStops,
            fltNbrList: service.fltNbrList,
            departureTime: service.departureTime,
            fare: fare
          };
        }
      }
    });
    return lowestDtd;
  }
  function createCarrierCurvesMap(carrierCurves) {
    var carrierCurvesFareMap = Object.create(null);
    _.forEach(carrierCurves, function (carrierCurve) {
      var fareMap = carrierCurvesFareMap[carrierCurve.entryKey] = Object.create(null);
      _.forEach(carrierCurve.fareCurve, function (point) {
        fareMap[point.dtd] = point;
      });
    });
    return carrierCurvesFareMap;
  }
  function createLowestUnmatchedFareData(compData) {
    return _.chain(compData).groupBy('carrier').reduce(function (result, carrierCurves) {
      var lowestFareCurve = {
        carrier: carrierCurves[0].carrier,
        departureDate: carrierCurves[0].departureDate,
        isHostFare: carrierCurves[0].isHostFare,
        fareCurve: []
      };
      var carrierCurvesMap = createCarrierCurvesMap(carrierCurves);
      _.forEach(carrierCurves[0].fareCurve, function (point) {
        var lowestFareServiceAtDtd = findServiceWithLowestFare(carrierCurves, carrierCurvesMap, point.dtd);
        if (lowestFareServiceAtDtd) {
          var lowestPoint = {
            dtd: point.dtd,
            departureTime: point.departureTime,
            fare: lowestFareServiceAtDtd.fare,
            lowestFareDepartureTime: lowestFareServiceAtDtd.departureTime,
            lowestFareNbrOfStopsAtDtd: lowestFareServiceAtDtd.nbrOfStops
          };
          lowestFareCurve.fareCurve.push(lowestPoint);
        } else {
          lowestFareCurve.fareCurve.push({
            dtd: point.dtd,
            departureTime: point.departureTime
          });
        }
      });
      result.push(lowestFareCurve);
      return result;
    }, []).value();
  }
  function createLowestMatchedFareData(compData, todayDtd) {
    var orderedEntries = _.chain(compData).filter({
      isHostFare: false
    }).transform(function (result, entry) {
      var todayDtdEntry = _.find(entry.fareCurve, {
        dtd: todayDtd
      });
      if (todayDtdEntry && !_.isUndefined(todayDtdEntry.fare)) {
        result.push({
          fare: parseFloat(todayDtdEntry.fare),
          entryKey: entry.entryKey
        });
      }
    }, []).orderBy('fare').value();
    if (orderedEntries.length !== 0) {
      var lowestFareServiceEntryKey = orderedEntries[0].entryKey;
      return _.find(compData, {
        entryKey: lowestFareServiceEntryKey
      });
    } else {
      return undefined;
    }
  }
  function parseTime(timeStr) {
    return parseInt(timeStr.replace(':', ''));
  }
  function createClosestTime(compData, todayDtd, hostService) {
    var orderedEntries = _.chain(compData).filter({
      isHostFare: false
    }).transform(function (result, entry) {
      var todayDtdEntry = _.find(entry.fareCurve, {
        dtd: todayDtd
      });
      if (todayDtdEntry && !_.isUndefined(todayDtdEntry.departureTime)) {
        result.push({
          departureTime: parseTime(todayDtdEntry.departureTime),
          entryKey: entry.entryKey
        });
      }
    }, []).orderBy(function (entry) {
      return Math.abs(parseTime(hostService.departureTime) - entry.departureTime);
    }).value();
    if (orderedEntries.length !== 0) {
      var closestTimeServiceEntryKey = orderedEntries[0].entryKey;
      return _.find(compData, {
        entryKey: closestTimeServiceEntryKey
      });
    } else {
      return undefined;
    }
  }
  function getFlightNumbersFromServiceId(serviceId) {
    var flightNumbers = [];
    var singleServiceIds = serviceId.split('|');
    for (var i = 0; i < singleServiceIds.length; i++) {
      var singleService = singleServiceIds[i].split('.');
      var flightAndDate = singleService[2];
      var carrier = singleService[1];
      var flightNumber = carrier + flightAndDate.split('[')[0];
      flightNumbers.push(flightNumber);
    }
    flightNumbers = flightNumbers.join(',');
    return trim(flightNumbers);
  }
  function trim(value) {
    return value.replace(/\s/g, '');
  }
  function isDataForTodayDTD(entry, todayDtd) {
    return !_.isUndefined(_.find(entry.fareCurve, function (el) {
      return el.dtd === todayDtd && el.fare !== undefined;
    }));
  }
  function getHostService(compData, singleServiceId, todayDtd) {
    var flightNumbersFromService = getFlightNumbersFromServiceId(singleServiceId);
    return _.find(compData, function (entry) {
      return entry.isHostFare && entry.serviceId === singleServiceId && trim(entry.fltNbrList) === flightNumbersFromService && isDataForTodayDTD(entry, todayDtd);
    });
  }
  function filterDataByUserFilterSelection(compData, filter, todayDtd, legendFilter, singleServiceId) {
    var result = [];
    if (filter.mode === 'UNMATCHED') {
      result = _.filter(compData, function (entry) {
        return matchByStops(entry, filter);
      });
      if (filter.display === 'lowestCompFares') {
        result = createLowestUnmatchedFareData(result);
      }
    } else if (filter.mode === 'MATCHED' && (filter.matchType.fare || filter.matchType.time)) {
      var hostService = getHostService(compData, singleServiceId, todayDtd);
      if (hostService) {
        result.push(hostService);
        if (filter.matchType.fare) {
          var lowestFareCompEntry = createLowestMatchedFareData(compData, todayDtd);
          if (lowestFareCompEntry) {
            result.push(lowestFareCompEntry);
          }
        }
        if (filter.matchType.time) {
          var closestTimeCompEntry = createClosestTime(compData, todayDtd, hostService);
          if (closestTimeCompEntry) {
            result.push(closestTimeCompEntry);
          }
        }
        result = _.uniqBy(result, 'entryKey');
      }
    } else {
      result = compData;
    }
    return _.filter(result, function (entry) {
      return legendFilter.indexOf(entry.carrier) === -1;
    });
  }
  function buildChartData(compData, legendFilter, filter, colorMap, legendColorMap, todayDtd, singleServiceId) {
    var userFilteredData = filterDataByUserFilterSelection(compData, filter, todayDtd, legendFilter, singleServiceId);
    return _.map(userFilteredData, function (faresData) {
      return {
        isHostFare: faresData.isHostFare,
        carrier: faresData.carrier,
        nbrOfStops: faresData.nbrOfStops,
        fltNbrList: faresData.fltNbrList,
        dotted: faresData.isHostFare,
        fill: colorMap[faresData.entryKey] || legendColorMap[faresData.carrier].color,
        curveData: _.map(faresData.fareCurve, function (item) {
          var faresCurveItem = {
            dtd: item.dtd
          };
          if (item.dtd >= todayDtd) {
            faresCurveItem.value = item.fare;
            faresCurveItem.departureTime = item.lowestFareDepartureTime === undefined ? item.departureTime : item.lowestFareDepartureTime;
            faresCurveItem.lowestFareNbrOfStopsAtDtd = item.lowestFareNbrOfStopsAtDtd;
          }
          return faresCurveItem;
        }),
        pointData: _.map(buildPointData(faresData), function (item) {
          return {
            value: item.fare,
            dtd: item.dtd
          };
        })
      };
    });
  }
  function buildChartLegend(chartData, compCarriers, legendFilter, colorMap, reorderCarriers) {
    var activeItems = _.chain(chartData).uniqBy('carrier').map(function (item) {
      return item.carrier;
    }).value();
    var legendItems = _.chain(compCarriers).orderBy(['isHostFare', 'carrier'], ['desc', 'asc']).map(function (compCarrier) {
      var selected = legendFilter.indexOf(compCarrier.carrier) === -1;
      var disabled = activeItems.indexOf(compCarrier.carrier) === -1;
      return buildLegendItem(compCarrier, colorMap[compCarrier.carrier].color, selected, disabled);
    }).value();
    return reorderCarriers ? changeCarriersOrderSoHostCarrierIsLastVisibleElement(legendItems) : legendItems;
  }
  function transformCompetitorData(rawData, legendFilter, filter, todayDtd, singleServiceId, reorderCarriers) {
    var legendColorMap = colorService.getLegendColorMap(rawData.compCarriers);
    var colorMap = colorService.getCompetitorServiceColorMap(rawData.compData, legendColorMap);
    var chartData = buildChartData(rawData.compData, legendFilter, filter, colorMap, legendColorMap, todayDtd, singleServiceId);
    var legend = buildChartLegend(chartData, rawData.compCarriers, legendFilter, legendColorMap, reorderCarriers);
    return {
      data: chartData,
      legend: legend
    };
  }
  function getFilterMode(screen, mode, filter, availableServices, selectedServices) {
    if (screen === dataRetrieverConstantsService.FLIGHT_SCREEN) {
      return competitorFaresCommonService.isFilterTimeWindowOnly(filter) ? 'MATCHED' : 'UNMATCHED';
    }
    if (mode !== dataRetrieverConstantsService.SERVICE_MODE) {
      return 'UNMATCHED';
    }
    return competitorFaresCommonService.isSingleService(availableServices, selectedServices) ? 'MATCHED' : 'UNMATCHED';
  }
  function constructService(filter, screen, mode, selectedEntity) {
    return competitorFaresCommonService.isFilterTimeWindowOnly(filter) ? constructServiceOnFlights(screen, mode, selectedEntity) : '';
  }
  function getSingleService(mode, availableServices, selectedServices) {
    if (competitorFaresCommonService.isSingleService(availableServices, selectedServices) && mode === dataRetrieverConstantsService.SERVICE_MODE) {
      if (competitorFaresCommonService.isSingleServiceSelected(selectedServices)) {
        return selectedServices[0];
      } else {
        return availableServices[0];
      }
    }
    return undefined;
  }
  function getSingleServiceWrapper(screen, mode, filter, selectedEntity, availableServices, selectedServices) {
    return screen === dataRetrieverConstantsService.FLIGHT_SCREEN ? constructService(filter, screen, mode, selectedEntity) : getSingleService(mode, availableServices, selectedServices);
  }
  function prepareFilterAndGetData(searchData, compTimeWindowConfig, screen, mode, filter, legendFilter, selectedEntity, selectedServices) {
    var todayDtd = searchData[0];
    var availableServices = searchData[1];
    var singleService = getSingleServiceWrapper(screen, mode, filter, selectedEntity, availableServices, selectedServices);
    var singleServiceId = singleService ? singleService.serviceId : '';
    filter.mode = getFilterMode(screen, mode, filter, availableServices, selectedServices);
    return $q.all([retrieveCompetitorData(searchData[2].origin, searchData[2].destination, searchData[2].departureDate, todayDtd, singleServiceId, mode), {
      timeWindowLabel: competitorFaresChartTimeWindowService.getTimeWindowLabel(compTimeWindowConfig, singleService, screen, mode, filter, availableServices, selectedServices),
      todayDtd: todayDtd,
      singleServiceId: singleServiceId
    }]);
  }
  function changeHostCarrierPosition(legend, newPosition, hostCarrier) {
    legend = _.pull(legend, hostCarrier);
    legend.splice(newPosition, 0, hostCarrier);
  }
  function hasMoreThanMaxElements(legend) {
    return legend.length > MAX_LEGEND_ITEMS;
  }
  function changeCarriersOrderSoHostCarrierIsLastVisibleElement(legend) {
    if (_.isEmpty(legend)) {
      return [];
    }
    var legendCopy = _.cloneDeep(legend);
    var hostCarrier = _.find(legendCopy, {
      'isHostFare': true
    });
    if (!hostCarrier) {
      return legendCopy;
    }
    if (hasMoreThanMaxElements(legendCopy)) {
      changeHostCarrierPosition(legendCopy, MAX_LEGEND_ITEMS - 1, hostCarrier);
    } else {
      changeHostCarrierPosition(legendCopy, legendCopy.length - 1, hostCarrier);
    }
    return legendCopy;
  }
  function getData(params) {
    return competitorFaresChartSearchDataService.getSearchMetaData(params.screen, params.mode, params.selectedEntity).then(function (searchMetaData) {
      var searchData = searchMetaData[0];
      var compTimeWindowConfig = searchData[1];
      return prepareFilterAndGetData(searchData, compTimeWindowConfig, params.screen, params.mode, params.filter, params.legendFilter, params.selectedEntity, params.selectedServices);
    }).then(function (prevStepResults) {
      var competitorData = prevStepResults[0];
      var previousStepMetaData = prevStepResults[1];
      var transformedData = transformCompetitorData(competitorData, params.legendFilter, params.filter, previousStepMetaData.todayDtd, previousStepMetaData.singleServiceId, params.reorderCarriers);
      return {
        data: transformedData.data,
        verticalLineData: getVerticalLine(previousStepMetaData.todayDtd),
        timeWindowLabel: previousStepMetaData.timeWindowLabel,
        legendItems: transformedData.legend,
        isLegendCollapsible: transformedData.legend.length > MAX_LEGEND_ITEMS
      };
    });
  }
  return {
    getData: getData
  };
};
CompetitorFaresChartDataProviderService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ChartElementsConstants', 'UserPreferencesService', 'SearchCriteriaRuleFactory', 'CompetitorFaresColorProviderService', 'CompetitorFaresChartTimeWindowService', 'CompetitorFaresChartSearchDataService', 'CompetitorFaresCommonService'];
module.exports = CompetitorFaresChartDataProviderService;